(function (appComponents) {

	appComponents.services.b2bUnit = function (Components) {

		var b2bUnit = {
			get isUnitSet() {
				return (b2bUnit.currentUnit && b2bUnit.currentUnit.uid) ? true : false;
			},
			get unitType() {
				return (b2bUnit.currentUnit && b2bUnit.currentUnit.unitType) ? b2bUnit.currentUnit.unitType : false;
			},
			get thirdPartyAddresses() {
				return (b2bUnit.currentUnit && b2bUnit.currentUnit.addresses) ? b2bUnit.currentUnit.addresses : [];
			}
		};

		b2bUnit.name = "b2bUnit";

		b2bUnit.currentUnit = {};


		Components.getComponentPrototype().extend(b2bUnit);

		b2bUnit._modals = b2bUnit._getService("modals");
		b2bUnit._helpers = b2bUnit._getService("helpers");

		b2bUnit.pager = {
			pageNumber: 1,
			resultsPerPage: 5,
		};

		b2bUnit.currentFilters = {};

		b2bUnit.elements = {
			get changeUnitModal() {
				return $('[pc-container="b2bUnit--change-modal"]');
			},
			get changeUnitModalBody() {
				return $('[pc-container="b2bUnit--change-modal-body"]');
			},
			get searchUnitModal() {
				return $('[pc-container="b2bUnit--search-modal"]');
			},
			get tableResults() {
				return $('[pc-container="b2bUnit--table-results"]');
			},
			get states() {
				return $('[pc-container="b2bUnit--states"]');
			},
			get headerDisplay() {
				return $('[pc-container="b2bUnit--header-display"]');
			},
			get searchForm() {
				return $("[pc-container='b2bUnit--search-modal-form']");
			},
			get systemComponents() {
				return $('[pc-container="system--components--li"]');
			},
			get filterByTypeSelectorPcPartsOption(){
				return $('[pc-container="search-results--filters-current-type-selector"] option[value="pc-parts"]');
			},
			get filterByTypeSelector() {
				return $('[pc-container="search-results--filters-current-type-selector"]');
			},
			get filterByTypeSelectorGeneralSearchOption(){
				return $('[pc-container="search-results--filters-current-type-selector"] option[value="general-search"]');
			},
			get advancedSearchTopBar() {
				return $('.adv-searchicon');
			},
			get advancedSearchHomeBar(){
				return $('.dis-inline-table');
			},
			get priceAndAvail() {
				return $('[pc-container="search-results--batch-get-panda"]');
			}
		};

		b2bUnit.bindings = function () {
			$(document).on("click", "[pc-container='b2bUnit--header-display']", function () {
				b2bUnit.handlers.onHeaderDisplayClick();
			});
			$(document).on("click", "[pc-container='b2bUnit--results-show-more']", function () {
				b2bUnit.handlers.onResultsShowMore();
			});
			$(document).on("click", "[pc-container='b2bUnit--submit-search-form']", function () {
				b2bUnit.handlers.onSearchFormSubmit();
				return false;
			});
			$(document).on("submit", "form[pc-container='b2bUnit--search-modal-uid-form']", function () {
				var uid = $(this).find("input[name='uid']").val();
				var setDefault = $(this).closest(".dc-modal-body").find("input[name='chkDefaultUnit']:checked").val();
				b2bUnit.handlers.onSetUnitByUid(uid, setDefault);
				return false;
			});
			$(document).on("click", "[pc-container='b2bUnit--change-unit']", function () {
				var uid = $(this).parents("[pc-container='b2bUnit--unit']").attr("pc-value");
				var setDefault = $(this).closest(".dc-modal-body").find("input[name='chkDefaultUnit']:checked").val();
				b2bUnit.handlers.onChangeUnit(uid, setDefault);
			});
		};

		b2bUnit.populateAvailableUnits = function () {
			return b2bUnit._api.b2bUnit.getAvailableUnits().then(function (res) {
				if (res && res.status == 200) {
					b2bUnit.context.units = res.body;
					// b2bUnit.context.pagination = res.pagination;
				}
			});
		};
		
		b2bUnit.b2bUnitOnChange = function () {
			var unitType = b2bUnit.unitType;
			var curUrl =  window.location.href;
				if (unitType == "SAP") {
					b2bUnit.elements.systemComponents.show();
					b2bUnit.elements.advancedSearchTopBar.hide();
					b2bUnit.elements.advancedSearchHomeBar.hide();
					b2bUnit.elements.priceAndAvail.hide();
					if(b2bUnit.elements.filterByTypeSelectorPcPartsOption != undefined && b2bUnit.elements.filterByTypeSelectorPcPartsOption.length == 0){
						b2bUnit.elements.filterByTypeSelector.append($('<option>',
								 {
								    value: "pc-parts",
								    text : "System Components"
								}));
					}
					b2bUnit.elements.filterByTypeSelector.find('option:selected').removeAttr('selected');
					b2bUnit.elements.filterByTypeSelectorPcPartsOption.prop('selected',true);
					b2bUnit.elements.filterByTypeSelector.trigger("change");
					b2bUnit.elements.filterByTypeSelector.attr("disabled",true);
					$('.motors-lv-rm-sitemap').hide();
					$('.parts-lv-rm-sitemap').show();
					if(curUrl != null && curUrl != undefined && curUrl.indexOf("search-results") != -1){
						app.core.handlers.onGoTo(b2bUnit._links.searchGoToPcParts);
					}
				} else if (unitType == "ORACLE"){
					b2bUnit.elements.systemComponents.hide();
					b2bUnit.elements.advancedSearchTopBar.show();
					b2bUnit.elements.advancedSearchHomeBar.show();
					b2bUnit.elements.priceAndAvail.show();
					b2bUnit.elements.filterByTypeSelectorPcPartsOption.remove();
					b2bUnit.elements.filterByTypeSelector.attr("disabled",false);
					b2bUnit.elements.filterByTypeSelector.find('option:selected').removeAttr('selected');
					b2bUnit.elements.filterByTypeSelectorGeneralSearchOption.prop('selected',true);
					b2bUnit.elements.filterByTypeSelector.trigger("change");
					$('.motors-lv-rm-sitemap').show();
					$('.parts-lv-rm-sitemap').hide();
					if(curUrl != null && curUrl != undefined && curUrl.indexOf("search-results") != -1){
						app.core.handlers.onGoTo(b2bUnit._links.searchGoToAllParts);
					}
				}
		};

		b2bUnit.renderAvailableUnits = function () {
			var html = b2bUnit.templates.changeModalBody(b2bUnit.context);
			b2bUnit.elements.changeUnitModalBody.replaceWith(html);

			b2bUnit._applyScript.iCheck();
			b2bUnit._applyScript.niceScroll();
		};

		b2bUnit.showSearchCustomerIndexModal = function () {
			if (b2bUnit._role.flags.isUnitsAllowed) {
				b2bUnit.elements.searchUnitModal.modal("show");
			} else {
				b2bUnit.elements.changeUnitModalBody.modal("show");
			}
		};

		b2bUnit.renderAndShowChangeCustomerIndexModal = function (data) {
			if (b2bUnit.context.units != null) {
				b2bUnit.context.units = b2bUnit.context.units.concat(data.results);
			} else {
				b2bUnit.context.units = data.results;
			}
			b2bUnit.context.pager = data.pagination;

			var html = b2bUnit.templates.changeModalBody(b2bUnit.context);
			b2bUnit.elements.changeUnitModalBody.replaceWith(html);

			b2bUnit.elements.searchUnitModal.modal("hide");
			b2bUnit.elements.changeUnitModal.modal("show");

			b2bUnit._applyScript.iCheck();
			b2bUnit._applyScript.niceScroll();
		};

		b2bUnit.checkB2BUnit = function () {
			if (b2bUnit.isUnitSet) {
				return true;
			} else {
				b2bUnit.showSearchCustomerIndexModal();
				b2bUnit._applyScript.select2();

				return false;
			}
		};

		b2bUnit.getUnitByUid = function (uid) {
			var units = b2bUnit.context.units;
			var unitToReturn;
			units.forEach(function (el) {
				if (el.uid == uid) {
					unitToReturn = el;
				}
			});
			return unitToReturn;
		};

		b2bUnit.updateHeaderDisplay = function () {
			if (b2bUnit.isUnitSet) {
				var text = b2bUnit.currentUnit.name + " - " + b2bUnit.currentUnit.uid;
				b2bUnit.elements.headerDisplay.text(text);
			}
		};

		b2bUnit.applyNewUnit = function (unit) {
			b2bUnit.currentUnit = unit;

			b2bUnit.elements.searchUnitModal.modal("hide");
			b2bUnit.elements.changeUnitModal.modal("hide");

			b2bUnit.updateHeaderDisplay();
			// pub event to get recent quotes
			b2bUnit._events.dispatchEvent("b2bUnitChanged");
		};

		b2bUnit.prepareSearchData = function () {
			var searchData = b2bUnit.currentFilters;
			if (Object.keys(searchData).length === 0) {
				var formElement = b2bUnit.elements.searchForm;
				var hasErrors = b2bUnit._helpers.checkFormForErrors(formElement);
				if (hasErrors) return;
				var searchData = b2bUnit._utils.getFormData(formElement);
				b2bUnit.currentFilters = searchData;
			}

			jQuery.extend(searchData, b2bUnit.pager);

			return searchData;

		};

		b2bUnit.populateAndRenderUnits = function () {
			var searchData = b2bUnit.prepareSearchData();
			if (!searchData) return;
			b2bUnit._api.b2bUnit.search(searchData).then(function (res) {
				if (res && res.status == 200) {

					b2bUnit.renderAndShowChangeCustomerIndexModal(res.body);
					b2bUnit.pager.pageNumber++;
				} else {
					// error handler
					b2bUnit._modals.warning.show(b2bUnit._messages.noResults);
					console.log(res);
				}
			});
		};

		b2bUnit.handlers = {
			onResultsShowMore: function () {
				if (!b2bUnit._role.flags.isUnitsAllowed) return;

				b2bUnit.populateAndRenderUnits();
			},
			onHeaderDisplayClick: function () {
				if (b2bUnit._role.flags.isUnitsAllowed) {
					b2bUnit.elements.searchUnitModal.modal("show");
				} else {
					b2bUnit.elements.changeUnitModal.modal("show");
				}
			},
			onSearchFormSubmit: function () {
				if (!b2bUnit._role.flags.isUnitsAllowed) return;

				b2bUnit.pager.pageNumber = 1;
				b2bUnit.currentFilters = {};
				b2bUnit.context.units = null;

				b2bUnit.populateAndRenderUnits();
			},
			onSetUnitByUid: function (uid, setDefault) {
				var unit = {
					uid: uid
				};
				b2bUnit._api.b2bUnit.changeUnit(unit, setDefault).then(function (res) {
					if (res.status == 200) {
						b2bUnit.applyNewUnit(res.body);
						b2bUnit.b2bUnitOnChange();
					} else {
						b2bUnit._modals.warning.show(res.message);
					}
				}).fail(function (e) {
					console.log(e);
				});
				
			},
			onChangeUnit: function (uid, setDefault) {
				var unit = b2bUnit.getUnitByUid(uid);
				b2bUnit._api.b2bUnit.changeUnit(unit, setDefault).then(function (res) {
					if (res && res.status == 200) {
						b2bUnit.applyNewUnit(res.body);
						b2bUnit.b2bUnitOnChange();
					} else if (res) {
						b2bUnit._modals.warning.show(res.message);
					}
				});
			},

		};

		b2bUnit.init = function () {

			b2bUnit.currentUnit = b2bUnit._stash.b2bUnit;
			b2bUnit.updateHeaderDisplay();
			b2bUnit._bindings();

			b2bUnit._helpers.populateCountries();

			if (!b2bUnit._role.flags.isUnitsAllowed && b2bUnit._role.flags.isUser) {
				b2bUnit.populateAvailableUnits().then(function () {
					b2bUnit.renderAvailableUnits();
				}).fail(function (e) {
					console.log(e);
				});
			}
			
			// b2bUnit._events.registerHandler("controllerInitialized", b2bUnit.checkB2BUnit);

		};

		return b2bUnit;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});